import {
    GET_CONVERSATIONS,
    CLEAR_STATE,
    GET_CONVERSATION,
    SET_ERROR,
    CLEAR_ERROR,
    SET_LOADING,
    MESSAGE_SOCKET,
    CONVERSATION_SOCKET,
    DELETE_CONVERSATION,
    SET_FINAL,
    CREATE_LEAD,
    CREATE_BDC,
    UPDATE_CONVERSATION,
    CLEAR_CONVERSATION,
    SET_CURRENT_CONVERSATION_ID,
} from '../types';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import { handleMessageSocketUpdate } from '../../modules/conversations/helpers/handleMessageSocketUpdate';
import { clearChannelConversationsUnbind } from 'src/modules/conversations/helpers/clearChannelUnbind';
import { getUniqueSortedConversations } from 'src/modules/conversations/helpers/getUniqueSortedConversations';

export default (state, action) => {
    const { enqueueSnackbar } = useSnackbar();

    switch (action.type) {
        case UPDATE_CONVERSATION:
            if (action.successMessage) {
                enqueueSnackbar(action.successMessage, {
                    variant: 'success',
                });
            }

            let indexE = state.conversations.findIndex(
                (item) => item._id === action.payload._id
            );
            const conversationsUpdated =
                indexE >= 0
                    ? state.conversations.map((item) =>
                          item._id === action.payload._id
                              ? action.payload
                              : item
                      )
                    : state.conversations;
            return {
                ...state,
                conversations: conversationsUpdated,
                conversation: action.payload,
            };
        case CREATE_BDC:
            let indexUBDC = state.conversations.findIndex(
                (item) => item._id === action.payload._id
            );
            state.conversations[indexUBDC] = action.payload;
            return {
                ...state,
                conversation: action.payload,
            };
        case CREATE_LEAD:
            if (action.successMessage) {
                enqueueSnackbar(action.successMessage, {
                    variant: 'success',
                });
            }

            let indexU = state.conversations.findIndex(
                (item) => item._id === action.payload._id
            );
            const conversationsWithLead =
                indexU >= 0
                    ? state.conversations.map((item) =>
                          item._id === action.payload._id
                              ? action.payload
                              : item
                      )
                    : state.conversations;
            return {
                ...state,
                conversations: conversationsWithLead,
                conversation: action.payload,
            };
        case DELETE_CONVERSATION:
            let deleteC = state.conversations.filter(
                (item) => item._id !== action.payload
            );
            return {
                ...state,
                loading: false,
                conversation: {},
                conversations: deleteC,
            };
        case SET_FINAL:
            return {
                ...state,
                final: action.payload,
            };
        case CONVERSATION_SOCKET:
            let filterConversations = state.conversations.filter(
                (item) => item._id.toString() !== action.payload._id.toString()
            );

            return {
                ...state,
                conversations: [action.payload, ...filterConversations],
            };
        case MESSAGE_SOCKET:
            return handleMessageSocketUpdate(state, action);
        case CLEAR_ERROR:
            return {
                ...state,
                error: null,
            };
        case GET_CONVERSATION:
            let isRead = _.findIndex(
                state.conversations,
                (item) => item._id === action.payload._id
            );
            state.conversations[isRead] = action.payload;

            return {
                ...state,
                messages: action.payload.messages || [],
                conversation: action.payload,
                loading: false,
            };
        case SET_CURRENT_CONVERSATION_ID:
            return {
                ...state,
                currentBoundConversationId: action.payload,
            };

        case GET_CONVERSATIONS:
            let convers = [];
            if (action.reload) convers = getUniqueSortedConversations(action.payload);
            else
                convers = getUniqueSortedConversations([
                    ...state.conversations,
                    ...action.payload,
                ]);

            return {
                ...state,
                conversations: convers,
                pagination: action.pagination,
                lastItems: action.payload.length,
                final: action.final,
                loading: false,
            };

        case CLEAR_STATE:
            clearChannelConversationsUnbind({
                conversation: state?.conversation?._id
            })
            return {
                ...state,
                conversation: {},
                conversations: [],
                pagination: {},
                messages: [],
                error: null,
                currentBoundConversationId: null,
            };
        case CLEAR_CONVERSATION:
            clearChannelConversationsUnbind({
                conversation: state?.conversation?._id
            })
            return {
                ...state,
                conversation: {},
                messages: [],
                error: null,
                currentBoundConversationId: null,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        default:
            return state;
    }
};
